export default __webpack_public_path__ + "static/media/linkedin.ae971c80.svg";